var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevarrw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81886 13.5833C8.03813 13.364 8.05806 13.0209 7.87866 12.7791L7.81886 12.7098L2.49134 7.38201L7.81886 2.05421C8.03813 1.83494 8.05806 1.49182 7.87866 1.25003L7.81886 1.18076C7.59959 0.961484 7.25646 0.94155 7.01467 1.12095L6.9454 1.18076L1.18088 6.94528C0.961604 7.16455 0.94167 7.50767 1.12107 7.74947L1.18088 7.81874L6.9454 13.5833C7.1866 13.8245 7.57766 13.8245 7.81886 13.5833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevarrw);
export default __webpack_public_path__ + "static/media/prevarrw.e0b4d567c7fa19a4c384e7b07dc53afe.svg";
export { ForwardRef as ReactComponent };